import { Link } from "react-router-dom";

/** Logo als SVG (Symbol + Schrift): gestochen scharf auf jedem Display, Seitenverhältnis fest. */
export function KonsildentLogo({ className = "h-9" }: { className?: string }) {
  return (
    <svg viewBox="0 0 800 187" role="img" aria-label="Konsildent – Überweisen. Verbinden. Versorgen." className={`block w-auto shrink-0 ${className}`} style={{ aspectRatio: "800 / 187" }}>
      <image href="/icons/icon-512.png" x="0" y="0" width="187" height="187" />
      <text x="226" y="112" fontFamily="Inter, system-ui, sans-serif" fontWeight="700" fontSize="104" textLength="430" lengthAdjust="spacingAndGlyphs">
        <tspan fill="#0B5C75">Konsil</tspan><tspan fill="#1E9E8C">dent</tspan>
      </text>
      <text x="228" y="160" fontFamily="Inter, system-ui, sans-serif" fontWeight="500" fontSize="31" fill="#5B6B73" textLength="537" lengthAdjust="spacingAndGlyphs">ÜBERWEISEN. VERBINDEN. VERSORGEN.</text>
    </svg>
  );
}

export function KonsildentIcon({ className = "h-9 w-9" }: { className?: string }) {
  return <img src="/icons/icon-512.png" alt="Konsildent" className={`shrink-0 object-contain ${className}`} />;
}

export function Footer({ provided }: { provided?: boolean }) {
  return (
    <footer className="mt-12 border-t border-border bg-surface pb-20 sm:pb-0" data-testid="footer">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-4 py-6 text-sm text-text-muted sm:flex-row sm:items-center sm:justify-between">
        <nav className="flex flex-wrap gap-x-5 gap-y-2" aria-label="Rechtliches">
          <Link to="/impressum" className="text-text-muted underline hover:text-text" data-testid="footer-impressum">Impressum</Link>
          <Link to="/datenschutz" className="text-text-muted underline hover:text-text" data-testid="footer-datenschutz">Datenschutz</Link>
          <Link to="/nutzungsbedingungen" className="text-text-muted underline hover:text-text" data-testid="footer-nutzungsbedingungen">Nutzungsbedingungen</Link>
        </nav>
        <p>Diese Anwendung verwendet ausschließlich technisch notwendige Cookies.</p>
        {provided && (
          <p className="flex items-center gap-1.5" data-testid="footer-provided">
            <KonsildentIcon className="h-5 w-5" /> bereitgestellt von Konsildent
          </p>
        )}
      </div>
    </footer>
  );
}
